<div class="howto" *ngIf="settings?.how_to_interact">
    <div class="howto-inner scrollbars">
        <div class="howto-content">
            <!-- <div class="howto-graphic">
                <img [src]="settings.how_to_interact" alt="How to interact">
            </div> -->
            <div class="howto-video">
                <iframe id="vimeo_frame" src="https://player.vimeo.com/video/771720506?h=182c6c2c74&amp;badge=0&amp;autopause=1&amp;autoplay=1&amp;player_id=0&amp;app_id=58479&amp;byline=0&amp;title=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Augment Seattle How To from Home"></iframe>
                <!-- <iframe id="vimeo_frame" src="https://player.vimeo.com/video/771720506?h=182c6c2c74&amp;background=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Augment Seattle How To from Home"></iframe> -->
                <!-- <button class="howto-video-play" id="vimeo_play_button"></button> -->
                <!-- <script src="https://player.vimeo.com/api/player.js"></script>
                <script>
                    (function() {
                        console.log("inside closure!");
                        var iframe = document.querySelector('#vimeo_frame');
                        var player = new Vimeo.Player(iframe);
                        var button = document.querySelector("#vimeo_play_button");
                        player.on('play', function() {
                            console.log('Played the video');
                        });
                    })();
                </script> -->
            </div>
        </div>
    </div>
</div>
